import { render, staticRenderFns } from "./BuyOrderEdit.vue?vue&type=template&id=e4139068&"
import script from "./BuyOrderEdit.vue?vue&type=script&lang=js&"
export * from "./BuyOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports